import { APPLY_COUPON, REMOVE_COUPON } from "./actionTypes";

const initialState = {
    coupon: []
};

export default function (state = initialState, action) {
    switch (action.type) {
        case APPLY_COUPON:
            return { ...state, coupon: action.payload };
        case REMOVE_COUPON:
            return { ...state, coupon: {} };
        default:
            return state;
    }
}
